import axios from "axios";
import { getAuth } from "firebase/auth";

const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  if (typeof window !== "undefined") {
    const hostname = window.location.hostname || "";
    const isLocal =
      hostname.includes("localhost") || hostname.includes("127.0.0.1");

    if (isLocal) {
      return "http://127.0.0.1:5001/damia-gcp/us-central1/api";
    }
  }

  return "https://us-central1-damia-gcp.cloudfunctions.net/api";
};

const API_BASE_URL = getApiBaseUrl();

const RealTimeSMSService = {
  /**
   * Generate SMS message from email sample
   */
  generateSMSFromEmail: async (params) => {
    try {
      const headers = {
        "Content-Type": "application/json",
      };

      if (typeof window !== "undefined") {
        try {
          const auth = getAuth();
          const currentUser = auth.currentUser;

          if (currentUser) {
            const token = await currentUser.getIdToken(true);
            headers.Authorization = `Bearer ${token}`;
          }
        } catch (tokenError) {
          console.warn("Unable to obtain auth token for SMS:", tokenError);
        }
      }

      const response = await axios.post(
        `${API_BASE_URL}/generateSMSFromEmail`,
        params,
        { headers }
      );

      return response.data;
    } catch (error) {
      console.error("Error generating SMS:", error.response || error);

      const message =
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.message ||
        "Failed to generate SMS message";

      throw new Error(message);
    }
  },

  /**
   * Send SMS via Twilio
   */
  sendSMS: async (params) => {
    try {
      const headers = {
        "Content-Type": "application/json",
      };

      if (typeof window !== "undefined") {
        try {
          const auth = getAuth();
          const currentUser = auth.currentUser;

          if (currentUser) {
            const token = await currentUser.getIdToken(true);
            headers.Authorization = `Bearer ${token}`;
          }
        } catch (tokenError) {
          console.warn("Unable to obtain auth token:", tokenError);
        }
      }

      const response = await axios.post(`${API_BASE_URL}/sendSMS`, params, {
        headers,
      });

      return response.data;
    } catch (error) {
      console.error("Error sending SMS:", error.response || error);

      const message =
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.message ||
        "Failed to send SMS";

      throw new Error(message);
    }
  },

  /**
   * Get SMS history for a team
   */
  getSMSHistory: async (teamId, limit = 50) => {
    try {
      const headers = {
        "Content-Type": "application/json",
      };

      if (typeof window !== "undefined") {
        try {
          const auth = getAuth();
          const currentUser = auth.currentUser;

          if (currentUser) {
            const token = await currentUser.getIdToken(true);
            headers.Authorization = `Bearer ${token}`;
          }
        } catch (tokenError) {
          console.warn("Unable to obtain auth token:", tokenError);
        }
      }

      const response = await axios.get(
        `${API_BASE_URL}/getSMSHistory?teamId=${teamId}&limit=${limit}`,
        { headers }
      );

      return response.data;
    } catch (error) {
      console.error("Error getting SMS history:", error.response || error);
      throw new Error(
        error.response?.data?.error ||
          error.message ||
          "Failed to get SMS history"
      );
    }
  },
};

export default RealTimeSMSService;
